module.exports = __webpack_public_path__ + "/bundle/asset/admission3-1-9329818944ff7ec87129dd7f2acfd4d4.png";